import React from "react";

import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { DashboardMenuItem, MenuItemLink } from "react-admin";
import {
  // AuditIcon,
  InboundIcon,
  // InventoryMapIcon,
  LogoutIcon,
  OutboundIcon,
  SearchIcon,
  TrainIcon,
  TruckIcon,
} from "../../components/common/iconography";
import FolderSpecialOutlinedIcon from "@material-ui/icons/FolderSpecialOutlined";
import MapOutlinedIcon from "@material-ui/icons/MapOutlined";
import SpeedIcon from "@material-ui/icons/Speed";
import { AclType } from "../../utils/constants";
import { hasTracks } from "../../utils/locationUtils";
import { getEnv, isAuthorized } from "../../utils/appUtils";
import { sessionYardRunsDriverCheckIn } from "../../utils/gateAccess";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
  },
  open: {
    width: 210,
  },
  closed: {
    width: 55,
  },
}));

export const CrewMenu = ({ onMenuClick, dense }) => {
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  // No useMemo needed - computation is trivial and window.appUser is stable after login
  const showTrackManagement =
    hasTracks() &&
    (isAuthorized(AclType.TRACK_MANAGEMENT) ||
      isAuthorized(AclType.ASSIGN_LOCATION));
  const showWorkOrders = getEnv() === "dev";

  const open = useSelector((state) => state.admin.ui.sidebarOpen);

  useSelector((state) => state.theme);
  const dispatch = useDispatch();

  const handleMenuClick = (evt) => {
    if (onMenuClick) onMenuClick(evt);
    dispatch({ type: "CLEAR_SEARCH_STATE" });
  };

  const handleUtilizationMenuClick = (evt) => {
    if (onMenuClick) onMenuClick(evt);
    dispatch({ type: "CLEAR_SEARCH_STATE" });
  };

  return (
    <div
      className={classnames(classes.root, {
        [classes.open]: open,
        [classes.closed]: !open,
      })}
    >
      {" "}
      <DashboardMenuItem
        onClick={handleMenuClick}
        sidebarIsOpen={open}
        primaryText="Dashboard"
      />
      <MenuItemLink
        to={`/processShipments`}
        primaryText="Inbound Shipments"
        leftIcon={<InboundIcon />}
        onClick={handleMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/processOutboundShipments`}
        primaryText="Outbound Shipments"
        leftIcon={<OutboundIcon />}
        onClick={handleMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {showTrackManagement && (
        <MenuItemLink
          to="/trackManagement"
          primaryText="Track Management"
          leftIcon={<TrainIcon />}
          onClick={handleMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {isAuthorized(AclType.GATE_MANAGEMENT) &&
        sessionYardRunsDriverCheckIn() && (
          <MenuItemLink
            to={`/gateQueue`}
            primaryText="Gate Queue"
            leftIcon={<TruckIcon />}
            onClick={handleMenuClick}
            sidebarIsOpen={open}
            dense={dense}
          />
        )}
      {showWorkOrders && (
        <MenuItemLink
          to={`/processWorkOrders`}
          primaryText="Work Orders"
          leftIcon={<FolderSpecialOutlinedIcon />}
          onClick={handleMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {/* <MenuItemLink
          to="/processAudit"
          primaryText="Inventory Audit"
          leftIcon={<AuditIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
      /> */}
      <MenuItemLink
        to="/search"
        primaryText="Inventory Search"
        leftIcon={<SearchIcon />}
        onClick={handleMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {/* <MenuItemLink
          to="/locations"
          primaryText="Inventory Map"
          leftIcon={<InventoryMapIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
      /> */}
      <MenuItemLink
        to="/utilization"
        primaryText="Yard Utilization"
        leftIcon={<SpeedIcon />}
        onClick={handleUtilizationMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {/* <MenuItemLink
          to="/documents"
          primaryText="Documents"
          leftIcon={<FolderSpecialOutlinedIcon />}
          onClick={handleMenuClick}
          sidebarIsOpen={open}
          dense={dense}
      /> */}
      {window.appUser?.reloadYard.mapImage && (
        <MenuItemLink
          to="/maps"
          primaryText="Yard Map"
          leftIcon={<MapOutlinedIcon />}
          onClick={handleMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {isXSmall && (
        <MenuItemLink
          to="/logout"
          primaryText="Logout"
          leftIcon={<LogoutIcon />}
        />
      )}
    </div>
  );
};
